import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/ejercitoMasUsado.png'
import _imports_1 from '@/assets/icons/ejercitoMejorResultado.png'
import _imports_2 from '@/assets/icons/ejercitoPeorResultado.png'


const _withScopeId = n => (_pushScopeId("data-v-721d1c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-weight-bold" }
const _hoisted_2 = { class: "font-weight-bold" }
const _hoisted_3 = { class: "font-weight-bold" }
const _hoisted_4 = { class: "resultado-barra" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Icono personalizado",
  width: "60",
  height: "60"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ejército más usado: próximamente", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Icono personalizado",
  width: "60",
  height: "60"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ejército con mejor resultado: próximamente", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Icono personalizado",
  width: "60",
  height: "60"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ejército con peor resultado: próximamente", -1))

import { computed, ref } from "vue";
import { UsuarioDataDTO } from "@/interfaces/Usuario";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardEstadisticas',
  props: {
    usuario: {}
  },
  emits: ["filtroCambiar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const defaultUsuario = {
  partidasGanadas: 0,
  partidasPerdidas: 0,
  partidasEmpatadas: 0,
  numeroPartidasJugadas: 0
};

//Para el snackbar
const mostrarSnackbar = ref(false);
const textoSnackbar = ref("");

const usuarioData = computed(() => props.usuario ?? defaultUsuario);

const winRate = computed(() =>
  (usuarioData.value.partidasGanadas / usuarioData.value.numeroPartidasJugadas) * 100
);
const lossRate = computed(() =>
  (usuarioData.value.partidasPerdidas / usuarioData.value.numeroPartidasJugadas) * 100
);
const drawRate = computed(() =>
  (usuarioData.value.partidasEmpatadas / usuarioData.value.numeroPartidasJugadas) * 100
);

// Estado del filtro activo (win, loss, draw o null)
const filtroActivo = ref<'win' | 'loss' | 'draw' | null>(null);

// Emitir evento al padre cuando se cambia el filtro
const emit = __emit;

function toggleFiltro(tipo: 'win' | 'loss' | 'draw') {
  filtroActivo.value = filtroActivo.value === tipo ? null : tipo;
  emit('filtroCambiar', filtroActivo.value);

  // Texto descriptivo para el snackbar
  const mensajes = {
    win: "Filtrando por victorias",
    draw: "Filtrando por empates",
    loss: "Filtrando por derrotas",
    null: "Mostrando todas las partidas",
  };

  textoSnackbar.value = mensajes[filtroActivo.value ?? "null"];
  mostrarSnackbar.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center pa-0 mb-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, "Victorias: " + _toDisplayString(_ctx.usuario.partidasGanadas), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, "Empates: " + _toDisplayString(_ctx.usuario.partidasEmpatadas), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.usuario.partidasPerdidas > 0)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "4"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_3, "Derrotas: " + _toDisplayString(_ctx.usuario.partidasPerdidas), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "pb-0 pt-1 text-left",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        class: "ml-2",
                        color: "grey-lighten-1",
                        size: "20"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-filter-variant")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Pulsa sobre la barra para filtrar partidas")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        (winRate.value > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["victorias", { active: filtroActivo.value === 'win' }]),
                              style: _normalizeStyle({ flex: winRate.value.toFixed(2) }),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleFiltro('win')))
                            }, _toDisplayString(winRate.value.toFixed(2)), 7))
                          : _createCommentVNode("", true),
                        (drawRate.value > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["empates", { active: filtroActivo.value === 'draw' }]),
                              style: _normalizeStyle({ flex: drawRate.value.toFixed(2) }),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleFiltro('draw')))
                            }, _toDisplayString(drawRate.value.toFixed(2)), 7))
                          : _createCommentVNode("", true),
                        (lossRate.value > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(["derrotas", { active: filtroActivo.value === 'loss' }]),
                              style: _normalizeStyle({ flex: lossRate.value.toFixed(2) }),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleFiltro('loss')))
                            }, _toDisplayString(lossRate.value.toFixed(2)), 7))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_snackbar, {
                modelValue: mostrarSnackbar.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mostrarSnackbar).value = $event)),
                timeout: "1500",
                color: "indigo-darken-4",
                elevation: "3",
                location: "top",
                rounded: "lg",
                class: "px-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2",
                    color: "yellow-lighten-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-filter-check")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(textoSnackbar.value), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})